import * as types from '../constants/actionTypes';
const initialState = {
	listing : [],
	// put_revoke_state : "initial"
};

export default function dashboardReducer(state = initialState, action) {
	switch (action.type) {
		case types.GET_DISP_SUB_LIST:
			return {
                ...state,
                listing: action.listing
            }
		case types.GET_DISP_SUB_LIST_ADMIN:
			return {
                ...state,
                listingAdmin: action.listing
            }
		case types.GET_SUBDISPUTE_DETAIL:
			return {
                ...state,
                subDisputeDetail: action.subDisputeDetail
            }
		case types.GET_SUBDISPUTE_LIST:
			return {
                ...state,
                subDisputeList: action.subDisputeList
            }
		case types.GET_SEARCHED_DISPUTE_LIST:
			return {
                ...state,
                searchedDisputedList: action.searchedDisputedList
            }
		case types.ADD_SUB_DISPUTE_CONTENT:
			return {
                ...state,
                subDisputeContentAdded: action.data
            }
		case types.ADD_DISPUTE_CONTENT:
			return {
                ...state,
                disputeContentAdded: action.data
            }
		case types.GET_DISPUTED_APPOINTMENT_DETAILS:
			return {
                ...state,
                disputedAppointmentDetails: action.disputedAppointmentDetails
            }
		default:
			return state;
	}
}